/* eslint-disable no-restricted-imports */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';

export function ConfirmSamsungNumberDialog({
  samsungDialogOpen,
  setSamsungDialogOpen,
  samsungOrderNumber,
  setSamsungOrderNumber,
  handleRegisterSamsung,
}) {
  return (
    <Dialog
      open={samsungDialogOpen}
      onClose={() => setSamsungDialogOpen(false)}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>Registrar Pedido Samsung</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>Informe o número do pedido da Samsung para prosseguir.</Typography>
        <TextField
          fullWidth
          label='Número do Pedido Samsung *'
          variant='outlined'
          value={samsungOrderNumber}
          onChange={(e) => setSamsungOrderNumber(e.target.value)}
          placeholder='Ex: SAM-2025-001'
          style={{ marginTop: 16 }}
          helperText='Campo obrigatório'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setSamsungDialogOpen(false)}>Cancelar</Button>
        <Button
          onClick={handleRegisterSamsung}
          color='primary'
          variant='contained'
          disabled={!samsungOrderNumber || samsungOrderNumber.trim() === ''}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
